import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <>
      {/* Footer Start */}
      <div className="container-fluid footer py-5 wow fadeIn" data-wow-delay="0.2s" style={{ padding: '0 !important', margin: '0 !important', background: '#484848' }}>
        <div className="container" style={{ maxWidth: '100%', padding: '0 15px' }}>
          <div className="row" style={{ gap: 0, margin: 0, padding: '40px 0' }}>
            <div className="col-md-6 col-lg-6 col-xl-3" style={{ padding: '0 30px' }}>
              <div className="footer-item d-flex flex-column">
                <h4 className=" mb-4" style={{color:'#DE400E'}}>Newsletter</h4>
                <p className="text-white mb-3">Subscribe to our newsletter for the latest updates and special offers on batteries and power solutions.</p>
                <div className="position-relative rounded-pill">
                  <input className="form-control rounded-pill w-100 py-3 ps-4 pe-5" type="text" placeholder="Enter your email" style={{ margin: 0 }} />
                  <button type="button" className="btn btn-primary rounded-pill position-absolute top-0 end-0 py-2 mt-2 me-2">SignUp</button>
                </div>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3" style={{ padding: '0 30px' }}>
              <div className="footer-item d-flex flex-column">
                <h4 className=" mb-4" style={{color:'#DE400E'}}>Quick Links</h4>
                <Link to="/" className="text-white mb-2">Home</Link>
                <Link to="/about" className="text-white mb-2">About Us</Link>
                <Link to="/gallery" className="text-white mb-2">Gallery</Link>
                <Link to="#products" className="text-white mb-2">Products</Link>
                <Link to="/contact" className="text-white mb-2">Contact</Link>
                <a href="#!" className="text-white">My Account</a>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3" style={{ padding: '0 30px' }}>
              <div className="footer-item d-flex flex-column">
                <h4 className=" mb-4" style={{color:'#DE400E'}}>Information</h4>
                <Link to="/about" className="text-white mb-2">About Us</Link>
                <a href="#!" className="text-white mb-2">Delivery Information</a>
                <a href="#!" className="text-white mb-2">Privacy Policy</a>
                <a href="#!" className="text-white mb-2">Terms & Conditions</a>
                <a href="#!" className="text-white mb-2">Warranty</a>
                <a href="#!" className="text-white">FAQ</a>
              </div>
            </div>
            <div className="col-md-6 col-lg-6 col-xl-3" style={{ padding: '0 30px' }}>
              <div className="footer-item d-flex flex-column">
                <h4 className=" mb-4" style={{color:'#DE400E'}}>Featured Brands</h4>
                <a href="#!" className="text-white mb-2">Exide</a>
                <a href="#!" className="text-white mb-2">Luminous</a>
                <a href="#!" className="text-white mb-2">Amaron</a>
                <a href="#!" className="text-white mb-2">Torque</a>
                <a href="#!" className="text-white mb-2">Solar Solutions</a>
                <a href="#!" className="text-white">Inverters</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* Footer End */}

      {/* Copyright Start */}
      <div className="container-fluid copyright py-4" style={{ padding: '0 !important', margin: '0 !important', background: '#DE400E' }}>
        <div className="container" style={{ maxWidth: '100%', padding: '0 15px', textAlign: 'center' }}>
          <div className="row" style={{ gap: 0, margin: 0, alignItems: 'center', justifyContent: 'center' }}>
            <div style={{ textAlign: 'center' }}>
              <span className="text-white text-center">
                <a href="/" className="border-bottom text-white text-center">
                  <i className="fas fa-copyright text-light me-2"></i>Galaxy Power System
                </a>, All right reserved.
              </span>
            </div>
            {/* <div className="col-md-6" style={{ padding: '0 30px', textAlign: 'right', color: 'white' }}>
              Designed By <a className="border-bottom text-white" href="/">Galaxy Power</a>
            </div> */}
          </div>
        </div>
      </div>
      {/* Copyright End */}
    </>
  );
};

export default Footer;